// extracted by mini-css-extract-plugin
export default {"footer":"AddSupplierUserModal_footer__tQd9Q","body":"AddSupplierUserModal_body__KkjZi","emailField":"AddSupplierUserModal_emailField__-Fsv4"};